import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import { getClassRoomPage } from "@/api/managementCenter/classroom";
import { setLangt } from "@/api/overseasChinese/overseasChinese";
export default {
  name: "classroomQuery",
  components: {
    Sift: Sift
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      siftData: [{
        type: "text",
        key: "roomName",
        label: "教室名称",
        placeholder: "请输入教室名称",
        default: ""
      }],
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        name: ""
      },
      total: 0,
      multipleSelection: [],
      modelShow: false,
      form: {
        longitude: "",
        latitude: ""
      },
      rules: {
        longitude: [{
          required: true,
          message: "请填写经度",
          trigger: "blur"
        }, {
          pattern: /^[\-\+]?(0?\d{1,2}\.\d{1,20}|1[0-7]?\d{1}\.\d{1,20}|180\.0{1,20})$/,
          message: "值在-180～180之间，必须输入1-20位小数,例如:116.27490509960936"
        }],
        latitude: [{
          required: true,
          message: "请填写纬度",
          trigger: "blur"
        }, {
          pattern: /^[\-\+]?([0-8]?\d{1}\.\d{1,20}|90\.0{1,20})$/,
          message: "值在-90～90之间，必须输入1-20位小数,例如:39.9264008525172"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getListFn();
  },
  methods: {
    setJw: function setJw(row) {
      this.modelShow = true;
      this.form = {
        classRoomId: row.id,
        longitude: "",
        latitude: ""
      };
    },
    save: function save() {
      var _this = this;

      this.$refs["form"].validate(function (valid) {
        if (valid) {
          setLangt(_this.form).then(function (res) {
            if (res.data.code == "0") {
              _this.$message.success("设置成功!");

              _this.modelShow = false;

              _this.getListFn();
            } else {
              _this.$message.warning(res.data.msg || "设置失败!");
            }
          }).catch(function () {
            _this.$message.error("服务异常");
          });
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this2 = this;

      this.loading = true;
      getClassRoomPage(this.paramSearch).then(function (_ref) {
        var data = _ref.data;
        _this2.loading = false;

        if (data.code == 0) {
          _this2.list = data.data.records || [];
          _this2.total = data.data.total;
        }
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 下载二维码
    downId: function downId(row) {
      var url = "/hq/classroom/roomQR?id=" + row.id;
      this.downloadFn(url);
    },
    downloadFn: function downloadFn(url) {
      var _this3 = this;

      this.$DownLoad(url, function (res) {
        if (res.status == 200) {} else {
          _this3.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      } // error => {
      //     this.$alert(error, "提示", {
      //         confirmButtonText: "确定",
      //         type: "warning"
      //     });
      // }
      );
    },
    //批量下载
    downIds: function downIds() {
      var idList = this.multipleSelection.map(function (item) {
        return item.id;
      }).join(",");
      var url = "/hq/classroom/exportQRzip?idListStr=" + idList;
      this.downloadFn(url);
    },
    // 默认页面数据
    initPage: function initPage() {
      this.paramSearch = _objectSpread(_objectSpread(_objectSpread({}, this.paramSearch), this.$refs.needSift.getValue()), {}, {
        current: 1
      });
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    saveSuccess: function saveSuccess() {
      this.getListFn();
    }
  },
  watch: {},
  filters: {}
};